import axiosPost from "./axiosPost";

export const RNHZonaIns = async (credentials, data) => {
    const body = {
        service: "RNHZonaIns",
        params: {
            rnhZonaCod: data?.cod || null,
            rnhZonaNombre: data?.name || null,
            rnhZonaWKT: data?.wkt || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
